import { render, staticRenderFns } from "./ProductMap.vue?vue&type=template&id=b939a2a0"
import script from "./ProductMap.vue?vue&type=script&lang=js"
export * from "./ProductMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports